import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { LayoutBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { borderColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderColor";
import { borderRadius } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderRadius";
import { borderStyle } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderStyle";
import { borderWidth } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderWidth";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  DesignProp,
  GeneralProp,
  LayoutProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Section",
  version: 1,
  nameI18n: "builder_ui.block_type.section",
  category: [LayoutBlock],
  props: {
    children: {
      name: "Children",
      nameI18n: "builder_ui.prop_type.children",
      category: [LayoutProp],
      prop: "children",
      type: "children",
      accepts: [],
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        backgroundColor: {
          ...backgroundColor,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.backgroundColor,
        },
        backgroundImage: {
          ...backgroundImage,
          category: [DesignProp, GeneralProp],
        },
        borderWidth: {
          ...borderWidth,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderWidth,
        },
        borderColor: {
          ...borderColor,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderColor,
        },
        borderRadius: {
          ...borderRadius,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderRadius,
        },
        borderStyle: {
          ...borderStyle,
          category: [DesignProp, GeneralProp],
          defaultValue: defaultStyles.borderStyle,
        },
        sizing: {
          ...sizing,
          category: [DesignProp, SizingProp],
          defaultValue: defaultStyles.sizing,
        },
        margin: {
          ...margin,
          category: [DesignProp, MarginsProp],
          defaultValue: defaultStyles.margin,
        },
        padding: {
          ...padding,
          category: [DesignProp, PaddingsProp],
          defaultValue: defaultStyles.padding,
        },
      },
    },
  },
};
